<div class="stac-modal">
  <header class="stac-modal__header">
    <div class="stac-modal__brand">
      <span class="stac-modal__icon" aria-hidden="true">
        <i class="pi pi-images"></i>
      </span>
      <div class="stac-modal__title-wrap">
        <span class="stac-modal__title">STAC Collection Items</span>
        @if (!isLoading && !errorMessage && features.length > 0) {
          <span class="stac-modal__count">
            @if (searchQuery.trim()) {
              {{ filteredFeatures.length }} of {{ features.length }} item{{ features.length !== 1 ? 's' : '' }}
            } @else {
              {{ features.length }} item{{ features.length !== 1 ? 's' : '' }}
            }
          </span>
        }
      </div>
    </div>
    <button type="button" class="stac-modal__close" aria-label="Close" (click)="closeModal()">
      <i class="pi pi-times"></i>
    </button>
  </header>

  @if (isLoading) {
    <div class="stac-modal__loading" role="status" aria-live="polite">
      <div class="stac-modal__spinner"></div>
      <p class="stac-modal__loading-text">Fetching STAC items...</p>
    </div>
  }

  @if (!isLoading && errorMessage) {
    <div class="stac-modal__error">
      <i class="pi pi-exclamation-triangle"></i>
      <p class="stac-modal__error-text">{{ errorMessage }}</p>
    </div>
  }

  @if (!isLoading && !errorMessage && (!stacData || !stacData.features || stacData.features.length === 0)) {
    <div class="stac-modal__empty">
      <i class="pi pi-inbox stac-modal__empty-icon"></i>
      <p class="stac-modal__empty-title">No items found</p>
      <p class="stac-modal__empty-text">No STAC items are available for this collection.</p>
    </div>
  }

  @if (!isLoading && !errorMessage && features.length > 0) {
    <div class="stac-modal__content">
      <div class="stac-modal__list">
        @for (feature of features; track feature.id ?? $index; let i = $index) {
          <article class="stac-item" [class.stac-item--alt]="i % 2 === 1">
            <span class="stac-item__index" aria-hidden="true">{{ i + 1 }}</span>
            <div class="stac-item__body">
              <div class="stac-item__header">
                <h3 class="stac-item__title">{{ getFeatureTitle(feature) }}</h3>
                <div class="stac-item__action">
                  @if (feature.id) {
                    <button
                      type="button"
                      class="stac-item__download"
                      [disabled]="isDownloading"
                      (click)="downloadFeature(feature)"
                    >
                      <i class="pi pi-download"></i>
                      <span>Download</span>
                    </button>
                  } @else {
                    <span class="stac-item__na">N/A</span>
                  }
                </div>
              </div>
              @if (getFeatureDescription(feature); as desc) {
                <p class="stac-item__description">{{ desc }}</p>
              }
              @if (getFeatureType(feature) || getFeatureBbox(feature)) {
                <div class="stac-item__badges">
                  @if (getFeatureType(feature); as type) {
                    <span class="stac-item__badge" title="Asset type">{{ type }}</span>
                  }
                  @if (getFeatureBbox(feature); as bbox) {
                    <span class="stac-item__badge stac-item__badge--bbox" [title]="bbox">Bbox</span>
                  }
                </div>
              }
              @if (getFeatureDisplayProperties(feature).length > 0) {
                <div class="stac-item__props-wrap">
                  <button
                    type="button"
                    class="stac-item__props-toggle"
                    [attr.aria-expanded]="isPropertiesExpanded(feature)"
                    (click)="toggleProperties(feature)"
                  >
                    <i class="pi" [class.pi-chevron-down]="!isPropertiesExpanded(feature)" [class.pi-chevron-up]="isPropertiesExpanded(feature)"></i>
                    <span>Properties ({{ getFeatureDisplayProperties(feature).length }})</span>
                  </button>
                  @if (isPropertiesExpanded(feature)) {
                    <dl class="stac-item__properties">
                      @for (prop of getFeatureDisplayProperties(feature); track prop[0]) {
                        <div class="stac-item__prop-row">
                          <dt class="stac-item__prop-key">{{ formatPropertyKey(prop[0]) }}</dt>
                          <dd class="stac-item__prop-value">{{ prop[1] }}</dd>
                        </div>
                      }
                    </dl>
                  }
                </div>
              }
            </div>
          </article>
        } @empty {
          <p class="stac-modal__no-results">No items match "{{ searchQuery }}"</p>
        }
      </div>
    </div>
  }
</div>
